module.exports = __webpack_public_path__ + "static/vr-live-downtown.b9d55c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vr-live-downtown.jpg
// module id = 351
// module chunks = 52007029612993 174448160903362